import BoxWithCta from "./BoxWithCta";

export default BoxWithCta;
